const TargetSVG = () => {
  return (
    <svg
      width="100%" /* fits the width of the SVG to the container */
      height="100%" /* fits the height of the SVG to the container */
      viewBox="0 0 100 100" /* sets the coordinate system */
      xmlns="http://www.w3.org/2000/svg">
      {/* <!-- Outer Circle --> */}
      <circle
        cx="50"
        cy="50"
        r="40"
        className="stroke-neutralLight"
        stroke-width="3"
        fill="none"
      />

      {/* <!-- Inner Circle --> */}
      <circle
        cx="50"
        cy="50"
        r="25"
        className="stroke-neutralLight"
        stroke-width="3"
        fill="none"
      />

      {/* <!-- Horizontal line left --> */}
      <line
        x1="0"
        y1="50"
        x2="35"
        y2="50"
        className="stroke-neutralLight"
        stroke-width="3"
      />

      {/* <!-- Horizontal line right --> */}
      <line
        x1="65"
        y1="50"
        x2="100"
        y2="50"
        className="stroke-neutralLight"
        stroke-width="3"
      />

      {/* <!-- Vertical line top --> */}
      <line
        x1="50"
        y1="0"
        x2="50"
        y2="35"
        className="stroke-neutralLight"
        stroke-width="3"
      />

      {/* <!-- Vertical line bottom --> */}
      <line
        x1="50"
        y1="65"
        x2="50"
        y2="100"
        className="stroke-neutralLight"
        stroke-width="3"
      />

      {/* <!-- Inner cross section --> */}

      {/* <!-- Vertical line bottom --> */}
      <line
        x1="50"
        y1="53"
        x2="50"
        y2="62"
        className="stroke-neutralLight"
        stroke-width="1"
      />

      {/* <!-- Vertical line top --> */}
      <line
        x1="50"
        y1="38"
        x2="50"
        y2="47"
        className="stroke-neutralLight"
        stroke-width="1"
      />

      {/* <!-- Horizontal line left --> */}
      <line
        x1="47"
        y1="50"
        x2="38"
        y2="50"
        className="stroke-neutralLight"
        stroke-width="1"
      />

      {/* <!-- Horizontal line right --> */}
      <line
        x1="53"
        y1="50"
        x2="62"
        y2="50"
        className="stroke-neutralLight"
        stroke-width="1"
      />
    </svg>
  );
};

export default TargetSVG;
